module.exports = __webpack_public_path__ + "img/colecao-berardo.8d6d1858.jpg";